module.exports = __webpack_public_path__ + "static/media/pdf.be27ab55.svg";